const led_settings_list = [
  { id: "led_enable", value: "en_blink", config: "blink", label: "led_en_blinking_no_usb" },
  { id: "led_disable", value: "dis_blink", config: "unblink", label: "led_dis_blinking_no_usb" },
  { id: "led_turn_off", value: "turn_off", config: "all_off", label: "led_turn_off" },
];

export const led = {
  led_settings: led_settings_list,
};

export default led;
